import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {ModalCharteDeontologiqueComponent} from '../modal-charte-deontologique/modal-charte-deontologique.component';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {TexteAdministrable} from '../../../interface/api/TexteAdministrable';
import {api} from '../../../api/api-dictionnary';
import {HydraService} from '../../../core/services/hydra.service';
import {TexteAdministrableTranslation} from '../../../interface/api/TexteAdministrableTranslation';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../../pipes/safeHtml.pipe';

@Component({
    selector: 'app-modal-texte-administrable',
    templateUrl: './modal-texte-administrable.component.html',
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatDialogClose, TranslateModule, SafeHtmlPipe]
})
export class ModalTexteAdministrableComponent implements OnInit {
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalCharteDeontologiqueComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    auth = inject(AuthentificationService);



    public texteAdministrableTranslated: TexteAdministrableTranslation;


    constructor() {
    }

    ngOnInit() {
        if (this.data != null) {
            this.loadTexteAdministrable();
        }
    }

    public loadTexteAdministrable() {
        this.hydraService
            .getById(api.TexteAdministrables + '/' + this.data)
            .subscribe((res: TexteAdministrable) => {
                this.texteAdministrableTranslated = res.translations.find(
                    (trans: TexteAdministrableTranslation) => trans.locale == this.auth.getLangueForUser()
                );
            });
    }
}
